import React from "react";
import { ColorPickerFab } from "components";
import "./styles.css";

const ColorPickerSection = ({ options, isVisible }) => (
  <>
    {!options && null}
    <div className="color-picker-fixed-section">
      <div className="color-picker-fixed-section-header-text">Customize Colors</div>
      <div className="color-picker-fixed-section-content-wrapper">
        {
          isVisible && options.map(option => (
            <ColorPickerFab color={option.color} onChange={option.onChange} text={option.text} />
          ))
        }
      </div>
    </div>
  </>
);

export default ColorPickerSection;
